// Recognisable payment-brand badges rendered as inline SVG (no external deps).
const Box = ({ children, label }) => (
  <span
    aria-label={label}
    className="inline-flex h-6 w-9 flex-none items-center justify-center overflow-hidden rounded-md border border-[#F2E8E6] bg-white shadow-sm sm:h-7 sm:w-11"
  >
    {children}
  </span>
);

const Visa = () => (
  <svg viewBox="0 0 48 30" className="h-full w-full">
    <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="13" fill="#1A1F71" letterSpacing="0.5">VISA</text>
  </svg>
);

const Mastercard = () => (
  <svg viewBox="0 0 48 30" className="h-full w-full">
    <circle cx="20" cy="15" r="8.5" fill="#EB001B" />
    <circle cx="28" cy="15" r="8.5" fill="#F79E1B" />
    <path d="M24 8.5a8.5 8.5 0 0 0 0 13 8.5 8.5 0 0 0 0-13Z" fill="#FF5F00" />
  </svg>
);

const Amex = () => (
  <svg viewBox="0 0 48 30" className="h-full w-full">
    <rect width="48" height="30" rx="3" fill="#1F72CF" />
    <text x="24" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="9" fill="#fff" letterSpacing="0.3">AMEX</text>
  </svg>
);

const PayPal = () => (
  <svg viewBox="0 0 48 30" className="h-full w-full">
    <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="10.5">
      <tspan fill="#003087">Pay</tspan><tspan fill="#0070E0">Pal</tspan>
    </text>
  </svg>
);

const ApplePay = () => (
  <svg viewBox="0 0 48 30" className="h-full w-full">
    <g fill="#000">
      <path d="M12.4 11.1c-.5.6-1.3 1-2 .95-.1-.8.3-1.65.75-2.17.5-.6 1.35-1.02 2.04-1.05.08.83-.25 1.65-.79 2.27Zm.78 1.24c-1.12-.06-2.07.63-2.6.63-.55 0-1.36-.6-2.24-.58-1.15.02-2.22.67-2.8 1.7-1.2 2.08-.31 5.16.85 6.85.57.83 1.25 1.76 2.14 1.73.85-.03 1.18-.55 2.2-.55 1.03 0 1.32.55 2.22.53.92-.02 1.5-.84 2.07-1.68.65-.96.92-1.89.93-1.94-.02-.01-1.79-.69-1.8-2.73-.02-1.71 1.39-2.52 1.46-2.57-.8-1.18-2.05-1.31-2.49-1.34Z" />
    </g>
    <text x="20" y="20" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="10" fill="#000">Pay</text>
  </svg>
);

const Afterpay = () => (
  <svg viewBox="0 0 48 30" className="h-full w-full">
    <rect width="48" height="30" rx="3" fill="#B2FCE4" />
    <text x="24" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="7.5" fill="#000">afterpay</text>
  </svg>
);

const MAP = { Visa, Mastercard, Amex, PayPal, "Apple Pay": ApplePay, Afterpay };

export const AfterpayBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center rounded-md bg-[#B2FCE4] px-2 py-0.5 text-[0.72rem] font-bold lowercase leading-none tracking-tight text-[#0A0A0A] ${className}`}>afterpay</span>
);

export const PaymentIcons = ({ methods = ["Visa", "Mastercard", "Amex", "PayPal", "Apple Pay", "Afterpay"], className = "" }) => (
  <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="payment-icons">
    {methods.map((m) => {
      const Logo = MAP[m];
      return Logo ? <Box key={m} label={m}><Logo /></Box> : null;
    })}
  </div>
);
